import React, { useEffect, useState } from "react";
import { getGlobalState } from "../../../utils/globalState";
import {
  getAccessRequests,
  approveDenyAccessRequest,
} from "../../../utils/api";

const AccessRequests = ({ expandedSections, toggleSection, runAs }) => {
  const myUserId = getGlobalState().myUserId;
  const runner = runAs === "admin" ? 2 : myUserId;
  const [accessRequests, setAccessRequests] = useState([]);
  const [loadingAccessRequests, setLoadingAccessRequests] = useState(false);

  // Filter state
  const [requesterFilter, setRequesterFilter] = useState("");
  const [dashboardFilter, setDashboardFilter] = useState("");

  const fetchAccessRequests = async () => {
    try {
      setLoadingAccessRequests(true);
      const accessRequestsData = await getAccessRequests(runner);
      setAccessRequests(accessRequestsData);
      setLoadingAccessRequests(false);
    } catch (error) {
      setLoadingAccessRequests(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchAccessRequests();
  }, [myUserId]);

  function formatDateWithSuffix(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const getSuffix = (d) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };
    return `${day}${getSuffix(day)} ${month} ${year}`;
  }

  // Filtered requests
  const filteredRequests = accessRequests.filter(
    (request) =>
      request.user_full_name
        .toLowerCase()
        .includes(requesterFilter.toLowerCase()) &&
      request.dashboard_name
        .toLowerCase()
        .includes(dashboardFilter.toLowerCase())
  );

  const handleApproveDenyAccessRequest = async (
    requestId,
    action,
    user,
    dashboard
  ) => {
    const decision = action.toLowerCase();
    const message = `This action does not grant access to ${dashboard} for ${user}. It merely sends a notification to them that their request has been ${decision}. To grant access to the dashboard please follow your company's standard approval process.\n\nPress OK to continue or Cancel to abort.`;
    const confirmed = window.confirm(message);
    if (!confirmed) return;
    try {
      await approveDenyAccessRequest(requestId, action);
      alert(
        "Access request from " +
          user +
          " to " +
          dashboard +
          " marked as " +
          decision
      );
      fetchAccessRequests();
    } catch (error) {
      console.error("Error approving/denying access request:", error);
    }
  };

  return (
    <div className="section">
      {/* commented cause I use new tabs view instead expand view */}

      {/* <div className="section-header" onClick={() => toggleSection('access')}>
                <h3>Access Requests</h3>
                <i className={`fas fa-chevron-${expandedSections.access ? 'up' : 'down'}`}></i>
            </div> */}
      {expandedSections.access && (
        <div className="section-content overview-grid">
          {loadingAccessRequests ? (
            <div className="loading">Loading...</div>
          ) : accessRequests.length > 0 ? (
            <div className="overflow-x-auto rounded-lg shadow">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                <tr>
                  <th
                          scope="col"
                          className="font-bold px-6 py-3 text-left text-sm text-gray-500 tracking-wider"
                        >Requester Full Name</th>
                  <th
                          scope="col"
                          className="font-bold px-6 py-3 text-left text-sm text-gray-500 tracking-wider"
                        >Dashboard Name</th>
                  <th
                          scope="col"
                          className="font-bold px-6 py-3 text-left text-sm text-gray-500 tracking-wider"
                        >Request Date</th>
                  <th
                          scope="col"
                          className="font-bold px-6 py-3 text-left text-sm text-gray-500 tracking-wider"
                        >Request Made</th>
                  <th
                          scope="col"
                          className="font-bold px-6 py-3 text-left text-sm text-gray-500 tracking-wider"
                        >Status</th>
                  <th
                          scope="col"
                          className="font-bold px-6 py-3 text-left text-sm text-gray-500 tracking-wider"
                        >Actions</th>
                </tr>
                <tr>
                  <th>
                    <input
                      type="text"
                      placeholder="Search..."
                      value={requesterFilter}
                      onChange={(e) => setRequesterFilter(e.target.value)}
                      style={{ width: "90%" }}
                      className="w-full mb-2 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    />
                  </th>
                  <th>
                    <input
                      type="text"
                      placeholder="Search..."
                      value={dashboardFilter}
                      onChange={(e) => setDashboardFilter(e.target.value)}
                      style={{ width: "90%" }}
                      className="w-full mb-2 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    />
                  </th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredRequests.map((request, index) => (
                  <tr key={request.request_id} className={
                            index % 2 === 0 ? "bg-white" : "bg-gray-50"
                          }>
                    <td  className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">{request.user_full_name}</td>
                    <td  className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">{request.dashboard_name}</td>
                    <td  className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">{formatDateWithSuffix(request.requested_datetime)}</td>
                    <td  className="px-6 py-4 whitespace-nowrap font-medium text-gray-900"  >
                      {Math.floor(
                        (Date.now() - new Date(request.requested_datetime)) /
                          (1000 * 60 * 60 * 24)
                      )}{" "}
                      days ago
                    </td>
                    <td  className="px-6 py-4 whitespace-nowrap">
                                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                request.status === "Active"
                                  ? "bg-green-100 text-green-800"
                                  : "bg-red-100 text-red-800"
                              }`}>{request.status}</span></td>
                    <td>
                      <button
                        onClick={() =>
                          handleApproveDenyAccessRequest(
                            request.request_id,
                            "Approved",
                            request.user_full_name,
                            request.dashboard_name
                          )
                        }
                        style={{ marginRight: "8px" }}
                        className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                      >
                        Mark Approved
                      </button>
                      <button
                        onClick={() =>
                          handleApproveDenyAccessRequest(
                            request.request_id,
                            "Rejected",
                            request.user_full_name,
                            request.dashboard_name
                          )
                        }
                        className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                      >
                        Mark Rejected
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          ) : (
            <div className="no-access-requests">No access requests found.</div>
          )}
        </div>
      )}
    </div>
  );
};

export default AccessRequests;
